export const childrenPaths = []

export default [
  {
    path: "/chat",
    name: "Chat",
    meta: {
      title: "Messages",
      icon: "bhi-forum",
      requiresAuth: true
    },
    component: () => import("@/views/Chat.vue")
  },
]